import { Fastlane } from '@velocity-exchange/icons';
import Tooltip from 'src/components/primitives/Tooltip/Tooltip';
import { useSwiftServerHealthCheck } from 'src/hooks/swift/useSwiftServerHealthcheck';
import { cj } from 'src/utils/classNames';
import { WithClassName } from 'src/utils/UtilityTypes';

export default function SwiftOfflineIndicator({ className }: WithClassName) {
	const isSwiftServerHealthy = useSwiftServerHealthCheck();

	if (isSwiftServerHealthy !== false) {
		return null;
	}

	return (
		<Tooltip
			content={
				'Gasless trading network is currently offline. You will temporarily need to pay gas fees for your trades. We will be back soon.'
			}
			className={cj('text-negative-red', className)}
		>
			<Fastlane size={16} />
		</Tooltip>
	);
}
